import { defineMessages } from 'react-intl';

export const messages = {
  details: defineMessages({
    practitionerInfo: {
      id: 'manage-services.practitioners.details.practitioner-info',
      defaultMessage: 'Practitioner info',
    },
    emailAddress: {
      id: 'manage-services.practitioners.details.email-address',
      defaultMessage: 'Email address',
    },
    venues: {
      id: 'manage-services.practitioners.details.venues',
      defaultMessage: 'Venues',
    },
    phoneNumber: {
      id: 'manage-services.practitioners.details.phone-number',
      defaultMessage: 'Phone number',
    },
    services: {
      id: 'manage-services.practitioners.details.services',
      defaultMessage: 'Services',
    },
    placeholder: {
      id: 'manage-services.practitioners.details.placeholder',
      defaultMessage: 'Select a practitioner to see more details',
    },
    editPractitioner: {
      id: 'manage-services.practitioners.details.edit-practitioner',
      defaultMessage: 'Edit',
    },
    deletePractitioner: {
      id: 'manage-services.practitioners.details.delete-practitioner',
      defaultMessage: 'Delete Practitioner',
    },
    fullName: {
      id: 'manage-services.practitioners.details.full-name',
      defaultMessage: '{firstName} {lastName}',
    },
    missingObjectsTitle: {
      id: 'manage-services.practitioners.details.missing-objects-title',
      defaultMessage: 'Missing Services',
    },
    missingObjectsCopy: {
      id: 'manage-services.practitioners.details.missing-objects-copy',
      defaultMessage: 'Associate at least one service to make this practitioner bookable.',
    },
  }),
  list: defineMessages({
    servicesCount: {
      id: 'manage-services.practitioners.list.services-count',
      defaultMessage: '{servicesCount, plural, one {# service} other {# services}}',
    },
    disabledTooltip: {
      id: 'manage-services.practitioners.list.disabled-tooltip',
      defaultMessage: 'Practitioners must be associated with services to be bookable by members.',
    },
  }),
  deleteModal: defineMessages({
    title: {
      id: 'manage-services.practitioners.delete-modal.title',
      defaultMessage: 'Delete practitioner',
    },
    description: {
      id: 'manage-services.practitioners.delete-modal.description',
      defaultMessage:
        'Are you sure you want to delete this practitioner? Existing reservations will not be canceled. Please cancel reservations directly in the “Appointments” tab.',
    },
    cancel: {
      id: 'manage-services.practitioners.delete-modal.cancel',
      defaultMessage: 'Cancel',
    },
    confirm: {
      id: 'manage-services.practitioners.delete-modal.confirm',
      defaultMessage: 'Confirm',
    },
  }),
  form: defineMessages({
    addPractitioner: {
      id: 'manage-services.practitioners.form.add-practitioner',
      defaultMessage: 'New practitioner',
    },
    editPractitioner: {
      id: 'manage-services.practitioners.form.edit-practitioner',
      defaultMessage: 'Edit {fullName}',
    },
    firstName: {
      id: 'manage-services.practitioners.form.first-name',
      defaultMessage: 'First name',
    },
    lastName: {
      id: 'manage-services.practitioners.form.last-name',
      defaultMessage: 'Last name',
    },
    emailAddress: {
      id: 'manage-services.practitioners.form.email-address',
      defaultMessage: 'Email address',
    },
    phoneNumber: {
      id: 'manage-services.practitioners.form.phone-number',
      defaultMessage: 'Phone number',
    },
    venues: {
      id: 'manage-services.practitioners.form.venues',
      defaultMessage: 'Venues',
    },
    firstNamePlaceholder: {
      id: 'manage-services.practitioners.form.first-name-placeholder',
      defaultMessage: 'Jane',
    },
    lastNamePlaceholder: {
      id: 'manage-services.practitioners.form.last-name-placeholder',
      defaultMessage: 'Doe',
    },
    emailAddressPlaceholder: {
      id: 'manage-services.practitioners.form.email-address-placeholder',
      defaultMessage: 'jane@studio.com',
    },
    cancel: {
      id: 'manage-services.practitioners.form.cancel',
      defaultMessage: 'Cancel',
    },
    save: {
      id: 'manage-services.practitioners.form.save',
      defaultMessage: 'Save',
    },
    delete: {
      id: 'manage-services.practitioners.form.delete',
      defaultMessage: 'Delete practitioner',
    },
    optionalLabel: {
      id: 'manage-services.practitioners.form.optional',
      defaultMessage: 'Optional',
    },
    practitionerInfo: {
      id: 'manage-services.practitioners.form.practitioner-info',
      defaultMessage: 'Practitioner details',
    },
    serviceHint: {
      id: 'manage-services.practitioners.form.service-hint',
      defaultMessage: 'In order for users to make a reservation, practitioner must be associated with a Service.',
    },
  }),
  validator: defineMessages({
    fieldRequired: {
      id: 'manage-services.practitioners.validator.field-required',
      defaultMessage: 'This field is required',
    },
    invalidEmail: {
      id: 'manage-services.practitioners.validator.invalid-email',
      defaultMessage: 'Please enter a valid email address',
    },
    invalidPhone: {
      id: 'manage-services.practitioners.validator.invalid-phone',
      defaultMessage: 'Please enter a valid phone number',
    },
    startTimeAfterEndTime: {
      id: 'manage-services.practitioners.validator.start-time-after-end-time',
      defaultMessage: 'Start time cannot be later than end time',
    },
    nameContainsStaff: {
      id: 'manage-services.practitioners.validator.name-contains-staff',
      defaultMessage: 'Field cannot contain "staff"',
    },
  }),
  success: defineMessages({
    practitionerCreated: {
      id: 'manage-services.practitioners.success.practitioner-created',
      defaultMessage: 'Practitioner was successfully added.',
    },
    practitionerEdited: {
      id: 'manage-services.practitioners.success.practitioner-edited',
      defaultMessage: 'Practitioner was successfully edited.',
    },
    practitionerDeleted: {
      id: 'manage-services.practitioners.success.practitioner-deleted',
      defaultMessage: 'Practitioner was successfully deleted.',
    },
  }),
  error: defineMessages({
    problemWithRequest: {
      id: 'manage-services.practitioners.error.problem-with-request',
      defaultMessage: 'There was a problem with your request.',
    },
  }),
  empty: defineMessages({
    header: {
      id: 'manage-services.practitioners.empty.header',
      defaultMessage: 'No practitioners added yet',
    },
    subheader: {
      id: 'manage-services.practitioners.empty.subheader',
      defaultMessage: 'Start now by adding a practitioner name',
    },
    button: {
      id: 'manage-services.practitioners.empty.button',
      defaultMessage: 'Add practitioner',
    },
    emptyIcon: {
      id: 'manage-services.practitioners.empty.empty-icon',
      defaultMessage: 'Empty practitioner icon',
    },
  }),
};
